import { render, staticRenderFns } from "./MediaCollections.vue?vue&type=template&id=27056efa&scoped=true"
import script from "./MediaCollections.vue?vue&type=script&lang=js"
export * from "./MediaCollections.vue?vue&type=script&lang=js"
import style0 from "./MediaCollections.vue?vue&type=style&index=0&id=27056efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27056efa",
  null
  
)

export default component.exports